import React, { useContext } from 'react';
import styled from 'styled-components';
import { FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
//import { faEye } from '@fortawesome/pro-solid-svg-icons';

import { SubHeading } from '../ui/SubHeading';
import { UserContext } from '../../contexts/UserContext';
import  VisibilityIcon  from '@material-ui/icons/Visibility';

const CardPreviewSettings = () => {
  const { Site, handleSiteChange } = useContext(UserContext);
  const { showPhoto, logoEnabled, showDetails } = Site;

  return (
    <div>
      <SubHeading> <VisibilityIcon style={Iconstyles}/> Display Settings</SubHeading>
      <Checkboxes>
        <FormControlLabel
          control={
            <Checkbox
              name='showPhoto'
              onChange={handleSiteChange}
              checked={showPhoto}
            />
          }
          label='Show photos on card'
        />
        <FormControlLabel
          control={
            <Checkbox
              name='logoEnabled'
              onChange={handleSiteChange}
              checked={logoEnabled}
            />
          }
          label='Show logo on card'
        />
        <FormControlLabel
          control={
            <Checkbox
              name='showDetails'
              onChange={handleSiteChange}
              checked={showDetails}
            />
          }
          label='Show site information on card'
        />
        <FormHelperText>
          These settings will not change your actual printed card design, they
          are just for preview purposes within the IDCapture software. Call us
          on 9240 4777 to discuss card design changes.
        </FormHelperText>
      </Checkboxes>
    </div>
  );
};

 const Iconstyles ={
   fontSize:'17px'
  }

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.1rem;
`;

export default CardPreviewSettings;
